import { render } from "./BusinessUnitDetails.vue?vue&type=template&id=47158f76"
import script from "./BusinessUnitDetails.vue?vue&type=script&lang=js"
export * from "./BusinessUnitDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__